const LOCALE_STORAGE_KEY = 'mooctest.locale'

export const LOCALE_ZH = 'zh-CN'
export const LOCALE_EN = 'en-US'

const EXACT_TEXT_MAP = {
  慕测平台: 'MoocTest',
  返回首页: 'Back to Home',
  欢迎回来: 'Welcome Back',
  '登录慕测平台，继续您的学习之旅': 'Sign in to MoocTest and continue your learning journey.',
  邮箱: 'Email',
  密码: 'Password',
  记住我: 'Remember me',
  '忘记密码？': 'Forgot password?',
  立即登录: 'Sign In',
  '登录中...': 'Signing in...',
  或: 'OR',
  微信登录: 'WeChat Login',
  '还没有账号？': "Don't have an account?",
  立即注册: 'Sign Up',
  用户注册: 'User Registration',
  '加入慕测平台，开启测试学习之旅': 'Join MoocTest and start your testing learning journey.',
  身份: 'Role',
  学生: 'Student',
  教师: 'Teacher',
  真实姓名: 'Real Name',
  确认密码: 'Confirm Password',
  '注册中...': 'Signing up...',
  '已有账号？': 'Already have an account?',
  进入平台: 'Enter Platform',
  注册: 'Sign Up',
  登录: 'Sign In',
  软件测试教学实践平台: 'Software Testing Education Platform',
  '集开发者测试、Web测试、嵌入式测试、算子测试于一体的综合教学平台': 'A comprehensive platform for Developer Testing, Web Testing, Embedded Testing, and Operator Testing.',
  开发者测试: 'Developer Testing',
  Web测试: 'Web Testing',
  嵌入式测试: 'Embedded Testing',
  算子测试: 'Operator Testing',
  智能系统测试: 'Intelligent System Testing',
  '开发者测试是软件开发生命周期中的关键环节，帮助开发人员在编码阶段就发现和修复问题。通过单元测试、集成测试和代码审查等方法，确保代码质量和功能正确性。掌握开发者测试技能，能够显著提升软件的可靠性和可维护性，减少后期修复成本。': 'Developer testing is a key part of the software lifecycle. It helps developers find and fix defects early during coding. Through unit testing, integration testing, and code review, teams can ensure code quality and functional correctness. Mastering developer testing significantly improves software reliability and maintainability while reducing late-stage fixing costs.',
  'Web测试专注于验证Web应用程序的功能、性能、安全性和用户体验。涵盖浏览器兼容性测试、响应式设计测试、API测试等多个方面。通过自动化测试工具和手动测试相结合，确保Web应用在不同环境和设备上都能稳定运行，为用户提供优质的在线体验。': 'Web testing focuses on validating functionality, performance, security, and user experience of web applications. It includes browser compatibility testing, responsive design testing, API testing, and more. By combining automated tools with manual testing, web apps can run reliably across environments and devices and deliver a high-quality online experience.',
  '嵌入式测试针对嵌入式系统和硬件设备进行专门的测试验证。包括硬件在环测试、实时性能测试、资源约束测试等。由于嵌入式系统的特殊性，测试需要考虑硬件限制、实时响应和可靠性要求。掌握嵌入式测试技术，是物联网和智能设备开发的必备技能。': 'Embedded testing is specialized validation for embedded systems and hardware devices. It includes hardware-in-the-loop testing, real-time performance testing, and resource-constrained testing. Because of the nature of embedded systems, testing must consider hardware limits, real-time response, and reliability requirements. Mastering embedded testing is essential for IoT and smart device development.',
  点击观看课程视频: 'Click to watch course video',
  '观看视频 →': 'Watch Video ->',
  课程视频中心: 'Course Video Center',
  课程视频: 'Course Video',
  正在获取视频播放地址: 'Loading video URL',
  '正在获取视频播放地址...': 'Loading video URL...',
  '您的浏览器不支持 video 标签，请直接访问视频地址播放。': 'Your browser does not support video playback. Please open the video URL directly.',
  视频不存在: 'Video Not Found',
  未匹配到当前视频资源: 'No matching video resource found.',
  '未找到对应视频，请检查路由参数或 OSS 地址配置。': 'Video not found. Please check route parameters or OSS configuration.',
  '后端未返回可用的视频签名地址。': 'Backend did not return an available signed video URL.',
  '签名地址获取失败，已尝试使用公开地址播放。': 'Failed to get signed URL. Tried playing with public URL.',
  '视频加载失败，请检查 OSS 对象路径、权限或防盗链配置。': 'Video load failed. Please check OSS object path, permissions, or anti-leech settings.',
  首页: 'Home',
  查看班级: 'View Classes',
  查看任务: 'View Tasks',
  个人主页: 'Profile',
  测试大赛: 'Testing Contest',
  题目管理: 'Problem Management',
  班级管理: 'Class Management',
  任务管理: 'Task Management',
  用户管理: 'User Management',
  系统配置: 'System Settings',
  退出: 'Logout',
  用户: 'User',
  日期: 'Date',
  时间: 'Time',
  清除: 'Clear',
  取消: 'Cancel',
  确定: 'Confirm',
  关闭: 'Close',
  确认: 'Confirm',
  确认操作: 'Confirm Action',
  '处理中...': 'Processing...',
  加载中: 'Loading',
  '加载中...': 'Loading...',
  详情加载中: 'Loading details',
  '详情加载中...': 'Loading details...',
  重新加载: 'Reload',
  暂无描述: 'No description',
  暂无任务: 'No tasks yet',
  暂无题目: 'No problems yet',
  暂无公告: 'No announcements yet',
  暂无附件: 'No attachments',
  未提交: 'Not Submitted',
  已提交: 'Submitted',
  未开始: 'Not Started',
  进行中: 'In Progress',
  已结束: 'Ended',
  已完成: 'Completed',
  下载: 'Download',
  下载中: 'Downloading',
  下载失败: 'Download Failed',
  上传中: 'Uploading',
  上传成功: 'Upload Success',
  上传失败: 'Upload Failed',
  删除: 'Delete',
  删除成功: 'Delete Success',
  删除失败: 'Delete Failed',
  保存成功: 'Saved',
  保存失败: 'Save Failed',
  保存中: 'Saving',
  更新成功: 'Updated',
  更新失败: 'Update Failed',
  创建成功: 'Created',
  创建失败: 'Create Failed',
  操作失败: 'Operation Failed',
  预览: 'Preview',
  暂无内容: 'No content',
  提交失败: 'Submit Failed',
  提交时间: 'Submitted At',
  状态: 'Status',
  题目状态: 'Problem Status',
  类型: 'Type',
  难度: 'Difficulty',
  简单: 'Easy',
  中等: 'Medium',
  困难: 'Hard',
  可用: 'Enabled',
  不可用: 'Disabled',
  未知: 'Unknown',
  基本信息: 'Basic Information',
  题目列表: 'Problem List',
  任务列表: 'Task List',
  任务总数: 'Total Tasks',
  题目名称: 'Problem Name',
  任务名称: 'Task Name',
  搜索任务名称: 'Search task name',
  '搜索任务名称...': 'Search task name...',
  '搜索任务名称、教师或班级...': 'Search task name, teacher, or class...',
  '搜索题目名称、创建者、班级...': 'Search problem name, creator, class...',
  任务描述: 'Task Description',
  题目描述: 'Problem Description',
  请输入题目名称: 'Please enter problem name',
  请输入任务名称: 'Please enter task name',
  请输入任务描述: 'Please enter task description',
  '请输入任务描述（支持 Markdown）': 'Please enter task description (Markdown supported)',
  选择时间: 'Select Time',
  请选择时间: 'Please select time',
  任务类型: 'Task Type',
  题目类型: 'Problem Type',
  '大小上限(MB)': 'Max Size (MB)',
  添加文件: 'Add File',
  题目数量: 'Problem Count',
  题目数: 'Problem Count',
  附件数: 'Attachment Count',
  使用次数: 'Usage Count',
  已选题目: 'Selected Problems',
  提交率: 'Submission Rate',
  开始时间: 'Start Time',
  启用时间: 'Start Time',
  结束时间: 'End Time',
  结束时间不能早于开始时间: 'End Time cannot be earlier than Start Time',
  'End Time 不能早于开始时间': 'End Time cannot be earlier than Start Time',
  平均分: 'Average Score',
  成绩: 'Score',
  学号: 'Student ID',
  班级: 'Class',
  班级名称: 'Class Name',
  班级描述: 'Class Description',
  班级编号: 'Class ID',
  班级总数: 'Total Classes',
  活跃班级: 'Active Classes',
  '平均人数/班': 'Average Students/Class',
  班级容量: 'Class Capacity',
  班级最大容量: 'Class Max Capacity',
  容量: 'Capacity',
  容量使用: 'Capacity Usage',
  当前人数: 'Current Size',
  总人数: 'Total Students',
  学生数: 'Student Count',
  教师总数: 'Total Teachers',
  授课中: 'Teaching',
  禁止加入: 'No Join',
  口令: 'Code',
  邀请码: 'Invitation Code',
  班级口令: 'Class Code',
  班级邀请码: 'Class Invitation Code',
  禁用班级: 'Disable Class',
  启用班级: 'Enable Class',
  未禁用: 'Not Disabled',
  班级设置: 'Class Settings',
  允许加入截止时间: 'Join Deadline Time',
  加入截止时间: 'Join Deadline Time',
  加入截止: 'Join Deadline',
  创建于: 'Created At',
  未限制: 'No Limit',
  班级正常开放中: 'Class is open',
  学生可以主动加入: 'Students can join actively',
  学生无需邀请码即可加入: 'Students can join without invitation code',
  学生需要邀请码才能加入: 'Students need an invitation code to join',
  学生无需班级邀请码即可加入: 'Students can join without class invitation code',
  学生需要班级邀请码才能加入: 'Students need a class invitation code to join',
  已开启: 'Open',
  已关闭: 'Closed',
  '简要描述课程内容、教学目标等...': 'Briefly describe course content, teaching goals, etc...',
  班级信息已更新: 'Class information updated',
  搜索班级名称: 'Search class name',
  '搜索班级名称...': 'Search class name...',
  '搜索班级名称、教师、口令...': 'Search class name, teacher, or code...',
  '搜索班级名称、教师、班级邀请码...': 'Search class name, teacher, or class invitation code...',
  所有教师: 'All Teachers',
  所有年份: 'All Years',
  '请输入班级名称（例如：软件测试2024春）': 'Please enter class name (e.g. Software Testing 2024 Spring)',
  班级创建后可正常加入: 'Students can join normally after class creation',
  班级创建后将立即禁用: 'Class will be disabled immediately after creation',
  请输入班级编号: 'Please enter class ID',
  请输入邀请码: 'Please enter invitation code',
  请输入班级邀请码: 'Please enter class invitation code',
  请输入班级描述: 'Please enter class description',
  '容量不能小于当前人数，且不能大于上限。': 'Capacity cannot be smaller than current size and cannot exceed the limit.',
  请输入容量: 'Please enter capacity',
  班级编号不能为空: 'Class ID cannot be empty',
  班级邀请码不能为空: 'Class invitation code cannot be empty',
  教师姓名与班级编号不匹配: 'Teacher name does not match class ID',
  教师姓名与班级邀请码不匹配: 'Teacher name does not match class invitation code',
  教师姓名: 'Teacher Name',
  请输入教师姓名和班级编号加入新班级: 'Please enter teacher name and class ID to join a new class',
  请输入教师姓名和班级邀请码加入新班级: 'Please enter teacher name and class invitation code to join a new class',
  请输入教师姓名: 'Please enter teacher name',
  加入: 'Join',
  确认退出班级: 'Confirm Leave Class',
  退出班级: 'Leave Class',
  班级邀请码已复制: 'Class invitation code copied',
  班级邀请码复制成功: 'Class invitation code copied',
  未找到班级邀请码: 'Class invitation code not found',
  请手动复制班级邀请码: 'Please copy the class invitation code manually',
  无法复制班级邀请码: 'Unable to copy class invitation code',
  点击复制班级邀请码: 'Click to copy class invitation code',
  '加入失败，请检查班级邀请码': 'Join failed, please check class invitation code',
  '例如：软件测试2024春': 'e.g. Software Testing 2024 Spring',
  '例如：源代码、实验报告': 'e.g. Source code, lab report',
  '例如：zip,java（英文逗号分隔）': 'e.g. zip,java (comma-separated)',
  '例如：10': 'e.g. 10',
  '上传学生列表（可选）': 'Upload Student List (Optional)',
  '上传学生列表(可选)': 'Upload Student List (Optional)',
  下载导入模板: 'Download Import Template',
  上传文件: 'Upload File',
  '请上传包含学生姓名、学号、邮箱等信息的表格文件': 'Please upload a table file including student name, student ID, and email.',
  管理班级: 'Managed Classes',
  学生总数: 'Total Students',
  平台用户: 'Platform Users',
  教师数量: 'Teacher Count',
  学生数量: 'Student Count',
  加入班级: 'Join Class',
  我的班级: 'My Classes',
  已加入班级: 'Joined Classes',
  参与任务: 'Participated Tasks',
  进行中任务: 'In Progress Tasks',
  已提交任务: 'Submitted Tasks',
  任务已完成: 'Task completed',
  您已提交所有题目的附件: 'You have submitted attachments for all problems',
  平均分数: 'Average Score',
  进度: 'Progress',
  人数: 'Students',
  发布任务: 'Published Tasks',
  '管理班级、学生总数、发布任务': 'Managed Classes, Total Students, Published Tasks',
  '发布中...': 'Publishing...',
  '班级信息缺失，无法发布任务': 'Missing class info. Unable to publish task.',
  班级信息缺失: 'Missing class info',
  发布任务失败: 'Failed to publish task',
  管理员: 'Admin',
  表单不完整: 'Form Incomplete',
  '表单不完整：请填写必填项': 'Form Incomplete: Please fill in required fields',
  '表单不完整:请填写必填项': 'Form Incomplete: Please fill in required fields',
  '表单不完整：请至少选择一个题目': 'Form Incomplete: Please select at least one problem',
  '表单不完整:请至少选择一个题目': 'Form Incomplete: Please select at least one problem',
  输入无效: 'Invalid Input',
  请选择: 'Please select',
  不限: 'No Limit',
  请填写完整: 'Please complete all required fields',
  请填写必填项: 'Please fill in required fields',
  请选择关联班级: 'Please select related class',
  请至少选择一个题目: 'Please select at least one problem',
  未命名文件: 'Unnamed File',
  公开: 'Public',
  私密: 'Private',
  私有: 'Private',
  已启用: 'Enabled',
  已禁用: 'Disabled',
  启用: 'Enable',
  禁用: 'Disable',
  失败: 'Failed',
  成功: 'Success',
  提示: 'Notice',
  搜索: 'Search',
  返回: 'Back',
  邮箱或密码错误: 'Invalid email or password',
  '账号不可用，请联系管理员。': 'Account unavailable. Please contact admin.',
  登录成功: 'Login Successful',
  登录失败: 'Login Failed',
  注册成功: 'Registration Successful',
  注册失败: 'Registration Failed',
  注册申请已提交: 'Registration Request Submitted',
  找回密码: 'Reset Password',
  '待集成微信开放平台登录接口': 'WeChat Open Platform login integration pending.',
  '请联系管理员或查看注册邮箱中的密码重置链接': 'Please contact admin or check the reset link in your registered email.',
  '请输入邮箱地址': 'Please enter your email address',
  '请输入有效的邮箱地址': 'Please enter a valid email address',
  '请输入密码': 'Please enter your password',
  '请输入真实姓名': 'Please enter your real name',
  '姓名至少需要2个字符': 'Name must be at least 2 characters',
  '密码至少需要6个字符': 'Password must be at least 6 characters',
  '请确认密码': 'Please confirm your password',
  '两次输入的密码不一致': 'Passwords do not match',
  '请选择身份': 'Please select a role',
  '注册失败，请稍后重试': 'Registration failed. Please try again later.',
  '获取下载链接失败': 'Failed to get download link',
  '未获取到下载链接': 'No download link available',
  '获取成功': 'Fetched successfully',
  '请输入您的邮箱地址': 'Please enter your email address',
  '请输入您的密码': 'Please enter your password',
  '请输入您的真实姓名': 'Please enter your real name',
  '请输入密码（至少6位）': 'Please enter password (at least 6 characters)',
  '请再次输入密码': 'Please enter password again',
  '专业的软件测试学习平台': 'A professional software testing learning platform',
  '公开发布': 'Public',
  '仅自己可见': 'Private (Only visible to yourself)',
  '切换为公开': 'Switch to Public',
  '切换为私密': 'Switch to Private',
  '任何人都可以浏览题目并看到标题与内容': 'Anyone can browse the problem and view its title and content',
  '题目不会出现在公开列表中': 'The problem will not appear in public lists',
  '会出现在题库列表，支持被搜索': 'Will appear in the problem library and support search',
  '不公开展示，适合草稿或内部题目': 'Not displayed publicly, suitable for drafts or internal problems',
  '点击或拖拽文件到此处添加附件': 'Click or drag files here to add attachments',
  '支持任意文件': 'Supports any file type',
  '未加入': 'Not Joined',
  '判题中...': 'Grading...',
  '智能评价分析中': 'AI analysis in progress',
  '智能评价分析中...': 'AI analysis in progress...',
  导出报告: 'Export Report',
  学情分析: 'Learning Analysis',
  改进建议: 'Improvement Suggestions',
  排名: 'Rank',
  姓名: 'Name',
  操作: 'Actions',
  文件: 'File',
  '正在加载个人主页...': 'Loading profile...',
  用户头像: 'User Avatar',
  更换头像: 'Change Avatar',
  未命名用户: 'Unnamed User',
  手机号: 'Phone',
  微信: 'WeChat',
  单位: 'Organization',
  地区: 'Region',
  工号: 'Employee ID',
  账号编号: 'Account ID',
  容量上限: 'Capacity Limit',
  '人/班': 'students/class',
  安全设置: 'Security Settings',
  登录密码: 'Login Password',
  定期修改密码可以提高账号安全性: 'Regular password updates improve account security.',
  修改密码: 'Change Password',
  账号绑定: 'Account Binding',
  '已绑定：': 'Bound: ',
  未绑定: 'Unbound',
  绑定: 'Bind',
  修改: 'Edit',
  解绑: 'Unbind',
  提交限制: 'Submission Limits',
  单次提交文件数量: 'Files per Submission',
  单文件大小上限: 'Max File Size',
  编辑个人资料: 'Edit Profile',
  当前密码: 'Current Password',
  新密码: 'New Password',
  确认新密码: 'Confirm New Password',
  '请输入当前密码': 'Please enter current password',
  '请输入新密码': 'Please enter new password',
  '请再次输入新密码': 'Please enter new password again',
  '请输入11位手机号': 'Please enter an 11-digit phone number',
  '请输入正确的11位手机号': 'Please enter a valid 11-digit phone number',
  '请输入微信号': 'Please enter WeChat ID',
  确认解绑: 'Confirm Unbind',
  解绑中: 'Unbinding',
  '解绑中...': 'Unbinding...',
  解绑成功: 'Unbind Successful',
  解绑失败: 'Unbind Failed',
  已解绑: 'Unbound',
  调整头像: 'Adjust Avatar',
  头像裁剪预览: 'Avatar Crop Preview',
  确认上传: 'Confirm Upload',
  缩放: 'Zoom',
  '正方形区域用于预览，圆圈内是最终头像范围。': 'The square area is for preview; the circle indicates the final avatar area.',
  文件过大: 'File Too Large',
  头像大小不能超过5MB: 'Avatar size cannot exceed 5MB',
  头像已更新: 'Avatar Updated',
  头像上传失败: 'Avatar Upload Failed',
  头像生成失败: 'Avatar Generation Failed',
  校验失败: 'Validation Failed',
  新密码至少6位: 'New password must be at least 6 characters',
  '密码已更新，请妥善保管新密码': 'Password updated. Please keep your new password safe.',
  '个人资料已更新': 'Profile updated',
  加载个人主页失败: 'Failed to load profile',
  请输入内容: 'Please enter content',
  绑定项: 'Binding Item',
  当前绑定项: 'Current Binding Item',
  省份: 'Province',
  城市: 'City',
  请选择省份: 'Please select a province',
  请选择城市: 'Please select a city',
  请先选择省份: 'Please select a province first',
  '地区按“省份 → 城市”选择；学校按省份筛选。': 'Choose region by "Province -> City"; schools are filtered by province.',
  '地区按“省份->城市”选择；学校按省份筛选。': 'Choose region by "Province -> City"; schools are filtered by province.',
  '学校按省份筛选。': 'Schools are filtered by province.',
  '单位名称（学校）': 'Organization Name (School)',
  '支持输入关键词匹配筛选，也可直接填写未收录学校。': 'You can search by keywords, or directly enter a school not listed.',
  '未匹配到学校，可直接输入学校全称': 'No matching school found. You can directly enter the full school name.',
  '请输入学校名称进行匹配': 'Enter school name to search.',
  '先选择省份，再筛选学校。': 'Select a province first, then filter schools.',
  '当前省份无学校数据，可直接填写学校名称。': 'No school data for current province. You can directly enter school name.',
  '地区按': 'Region by',
  '请使用真实姓名，真实姓名仅可修改一次，再次修改需要联系管理员': 'Please use your real name. It can only be changed once; further changes require admin support.',
  '请使用真实姓名，真实姓名仅可修改一次，再次修改需要联系管理员。': 'Please use your real name. It can only be changed once; further changes require admin support.',
  '真实姓名仅可修改一次，再次修改需联系管理员': 'Real name can only be changed once. Contact admin for further changes.'
  ,
  修改手机号: 'Edit Phone Number',
  确认修改: 'Confirm Changes',
  保存修改: 'Save Changes',
  创建新任务: 'Create New Task',
  关联班级: 'Related Class',
  请选择班级: 'Please select class',
  选择题目: 'Select Problems',
  '尚未选择题目，请从下方列表中选择': 'No problems selected yet. Please choose from the list below.',
  '搜索题目名称...': 'Search problem name...',
  '加载题目中...': 'Loading problems...',
  暂无可选题目: 'No available problems',
  '难度：': 'Difficulty: ',
  创建新题目: 'Create New Problem',
  创建题目: 'Create Problem',
  新建题目: 'Create Problem',
  创建中: 'Creating',
  新建班级: 'Create Class',
  创建班级: 'Create Class',
  '创建中...': 'Creating...',
  新建任务: 'Create Task',
  创建任务: 'Create Task',
  编辑题目: 'Edit Problem',
  编辑任务: 'Edit Task',
  立即结束任务: 'End Task Now',
  确认结束: 'Confirm End',
  所有状态: 'All Statuses',
  延长任务时间: 'Extend Task Time',
  当前结束时间: 'Current End Time',
  延长后结束时间: 'New End Time',
  延长1小时: 'Extend by 1 h',
  延长3小时: 'Extend by 3 h',
  延长1天: 'Extend by 1 d',
  延长3天: 'Extend by 3 d',
  自定义: 'Custom',
  确认延时: 'Confirm Extension',
  任务详情: 'Task Details',
  任务详细报告: 'Task Detail Report',
  任务发布成功: 'Task Published Successfully',
  任务已创建: 'Task Created',
  任务已删除: 'Task Deleted',
  删除任务失败: 'Failed to Delete Task',
  确认删除任务: 'Confirm Task Deletion',
  确认删除: 'Confirm Delete',
  确认添加: 'Confirm Add',
  确认绑定: 'Confirm Bind',
  创建题目失败: 'Failed to Create Problem',
  正在加载任务详情: 'Loading task details',
  '正在加载任务详情...': 'Loading task details...',
  加载任务详情失败: 'Failed to load task details',
  获取任务详情失败: 'Failed to fetch task details',
  无法获取任务详情: 'Unable to fetch task details',
  题目已创建: 'Problem Created',
  更新任务失败: 'Failed to Update Task',
  任务信息已更新: 'Task Information Updated',
  任务信息已成功更新: 'Task Information Updated Successfully',
  保存公告失败: 'Failed to Save Announcement',
  立即创建: 'Create Now',
  创建者: 'Creator',
  题目总数: 'Problem Count',
  公开题目: 'Public Problems',
  私有题目: 'Private Problems',
  所有类型: 'All Types',
  所有难度: 'All Difficulties',
  所有可见性: 'All Visibilities',
  难度等级: 'Difficulty Level',
  文件描述: 'File Description',
  允许后缀: 'Allowed Extensions',
  大小上限: 'Max Size',
  最大: 'Max',
  存储路径: 'Storage Path',
  文件名: 'File Name',
  选择模板: 'Choose Template',
  保存为模板: 'Save as Template',
  编辑模板: 'Edit Template',
  模板名称: 'Template Name',
  请输入模板名称: 'Please enter template name',
  暂无已保存的模板: 'No saved templates',
  '可选，例如：/code': 'Optional, e.g. /code',
  '可选，自动重命名提交文件': 'Optional, automatically rename the submitted file',
  提交说明: 'Submission Description',
  对提交内容的说明: 'Submission Description',
  公开描述: 'Public Description',
  学生可见的题目描述: 'Student-visible problem description',
  '学生可见的题目描述（支持 Markdown）': 'Student-visible problem description (Markdown supported)',
  私有描述: 'Private Description',
  教师和管理员可见的备注: 'Notes visible to teachers and administrators',
  '教师和管理员可见的备注（支持 Markdown）': 'Notes visible to teachers and administrators (Markdown supported)',
  仅教师可见的备注: 'Only teacher-visible notes',
  '仅教师可见的备注（支持 Markdown）': 'Notes visible only to teachers (Markdown supported)',
  内部附件: 'Internal Attachments',
  '（仅管理员和创建者可见）': '(Visible only to admins and creators)',
  仅管理员和创建者可见: 'Visible only to admins and creators',
  '点击或拖拽文件到此处添加内部附件': 'Click or drag files here to add internal attachments',
  '支持任意文件，仅管理员和创建者可见': 'Supports any file type, visible only to admins and creators',
  历史内部附件: 'Existing Internal Attachment',
  暂无内部附件: 'No internal attachments',
  下载全部内部附件: 'Download All Internal Attachments',
  可见性: 'Visibility',
  控制题目是否对外展示: 'Control whether the problem is displayed to the public',
  '会出现在题库列表，支持被检索': 'Will appear in the problem library and support search',
  '不公开展示，适合草稿或内部问题': 'Not displayed publicly, suitable for drafts or internal problems',
  题目附件: 'Problem Attachments',
  提交文件要求: 'Submission File Requirements',
  '文件数量等于规则条数。': 'File count should match the number of rules.',
  文件数量等于规则条数: 'File count should match the number of rules.',
  '当前所有提交文件要求将一起保存为模板，下次可一键填充。': 'All current submission file requirements will be saved as a template for one-click reuse next time.',
  应用模板: 'Apply Template',
  已应用模板: 'Template Applied',
  删除模板: 'Delete Template',
  保存模板失败: 'Failed to save template',
  更新模板失败: 'Failed to update template',
  删除模板失败: 'Failed to delete template',
  请输入名称: 'Please enter a name',
  模板名称不能为空: 'Template name cannot be empty',
  禁用题目: 'Disable Problem',
  删除题目: 'Delete Problem',
  请输入班级名称: 'Please enter class name',
  未启用: 'Not Enabled',
  退出任务: 'Exit Task',
  截止时间: 'Deadline Time',
  我的任务: 'My Tasks',
  完成情况: 'Completion',
  已截止: 'Expired',
  已过期: 'Expired',
  即将截止: 'Due Soon',
  未完成: 'Incomplete',
  算法设计: 'Algorithm Design',
  代码调试: 'Code Debugging',
  混合类型: 'Mixed',
  未知类型: 'Unknown Type',
  确认退出任务: 'Confirm Exit Task',
  退出成功: 'Exit Successful',
  已退出任务: 'Left the task',
  退出任务失败: 'Failed to exit task',
  退出中: 'Exiting',
  查看详情: 'View Details',
  请先加入班级以获取任务: 'Please join a class to get tasks',
  返回班级: 'Back to Classes',
  剩余时间: 'Remaining Time',
  '题目附件：': 'Problem Attachments: ',
  没有找到匹配的题目: 'No matching problems found',
  暂无班级: 'No classes yet',
  没有找到匹配的班级: 'No matching classes found',
  请等待管理员审核通过后登录: 'Please wait for admin approval before signing in',
  欢迎加入: 'Welcome to',
  待提交: 'To Submit',
  选择文件: 'Choose File',
  重新提交: 'Resubmit',
  '提交说明：': 'Submission Instructions: ',
  提交成功: 'Submit Success',
  请选择文件: 'Please Select File',
  请先选择要提交的文件: 'Please select the file(s) to submit first',
  班级详情: 'Class Details',
  总任务: 'Total Tasks',
  班级任务: 'Class Tasks',
  去完成: 'Go',
  加入任务: 'Join Task',
  '加入中...': 'Joining...',
  '加载任务中...': 'Loading tasks...',
  任务尚未开始: 'Task Not Started',
}

const TOKEN_TEXT_MAP = {
  软件测试: 'Software Testing',
  学习之旅: 'learning journey',
  慕测: 'MoocTest',
  测试平台: 'Testing Platform',
  班级邀请码: 'Class Invitation Code',
  班级口令: 'Class Code',
  邀请码: 'Invitation Code',
  口令: 'Code',
  请前往登录: 'Please sign in',
  教师账号待管理员审核通过后方可登录: 'Teacher account needs admin approval before sign-in',
  '账号已被禁用，请联系管理员': 'Account has been disabled. Please contact admin',
  登录成功: 'Login successful',
  登录失败: 'Login failed',
  注册成功: 'Registration successful',
  注册失败: 'Registration failed',
  题目: 'Problem',
  任务: 'Task',
  班级: 'Class',
  学生: 'Student',
  教师: 'Teacher',
  管理员: 'Admin',
  分析: 'Analysis',
  报告: 'Report',
  状态: 'Status',
  成绩: 'Score',
  提交: 'Submit',
  下载: 'Download',
  上传: 'Upload',
  删除: 'Delete',
  编辑: 'Edit',
  创建: 'Create',
  新: 'New',
  修改: 'Edit',
  
  更新: 'Update',
  保存: 'Save',
  取消: 'Cancel',
  确认: 'Confirm',
  关闭: 'Close',
  加载: 'Loading',
  开发者测试: 'Developer Testing',
  嵌入式测试: 'Embedded Testing',
  算子测试: 'Operator Testing',
  失败: 'Failed',
  成功: 'Success',
  剩余: 'Remaining',
  提交中: 'Submitting',
  下载中: 'Downloading',
  上传中: 'Uploading',
  进行中: 'In Progress',
  未开始: 'Not Started',
  已结束: 'Ended',
  已完成: 'Completed',
  未提交: 'Not Submitted',
  已提交: 'Submitted',
  未加入: 'Not Joined',
  等待中: 'Pending',
  判题中: 'Grading',
  提示: 'Notice',
  警告: 'Warning',
  错误: 'Error',
  重试: 'Retry',
  返回: 'Back'
}

const REGEX_RULES = [
  [/^欢迎回来，(.+?)[！!]$/, (_, name) => `Welcome back, ${name}!`],
  [/^欢迎加入慕测平台，(.+)（教师）。请等待管理员审核通过后登录。$/, (_, name) => `Welcome to MoocTest, ${name} (Teacher). Please wait for admin approval before signing in.`],
  [/^欢迎加入慕测平台，(.+)（学生）[！!]\s*请前往登录。$/, (_, name) => `Welcome to MoocTest, ${name} (Student)! Please sign in.`],
  [/^绑定(手机号|微信|GitHub|GitCode)$/, (_, label) => `Bind ${applyTokenRules(label)}`],
  [/^修改(手机号|微信|GitHub|GitCode)$/, (_, label) => `Edit ${applyTokenRules(label)}`],
  [/^(确定|确认)删除任务[「“"]?(.*?)[」”"]?吗？$/, (_, __, name) => `Delete task "${name}"?`],
  [/^(确定|确认)DeleteTask[「“"]?(.*?)[」”"]?吗？$/, (_, __, name) => `Delete task "${name}"?`],
  [/^(确定|确认)删除班级[「“"]?(.*?)[」”"]?吗？$/, (_, __, name) => `Delete class "${name}"?`],
  [/^(确定|确认)DeleteClass[「“"]?(.*?)[」”"]?吗？$/, (_, __, name) => `Delete class "${name}"?`],
  [/^确定要删除班级[「“"]?(.*?)[」”"]?吗？删除后将无法恢复。$/, (_, name) => `Delete class "${name}"? This action cannot be undone.`],
  [/^已绑定：(.+)$/, (_, value) => `Bound: ${value}`],
  [/^(.+)已解绑$/, (_, label) => `${applyTokenRules(label)} unbound`],
  [/^确定解绑(.+)（(.+)）吗？$/, (_, label, value) => `Confirm unbind ${applyTokenRules(label)} (${value})?`],
  [/^班级已禁用$/, () => 'Class disabled'],
  [/^班级已启用$/, () => 'Class enabled'],
  [/^题目已禁用$/, () => 'Problem disabled'],
  [/^题目已启用$/, () => 'Problem enabled'],
  [/^Class已禁用$/, () => 'Class disabled'],
  [/^Class已启用$/, () => 'Class enabled'],
  [/^Problem已禁用$/, () => 'Problem disabled'],
  [/^Problem已启用$/, () => 'Problem enabled'],
  [/^班级\s*(.+)\s*已禁用$/, (_, name) => `Class ${name} disabled`],
  [/^班级\s*(.+)\s*已启用$/, (_, name) => `Class ${name} enabled`],
  [/^题目\s*(.+)\s*已禁用$/, (_, name) => `Problem ${name} disabled`],
  [/^题目\s*(.+)\s*已启用$/, (_, name) => `Problem ${name} enabled`],
  [/^Class\s*(.+)\s*已禁用$/, (_, name) => `Class ${name} disabled`],
  [/^Class\s*(.+)\s*已启用$/, (_, name) => `Class ${name} enabled`],
  [/^Problem\s*(.+)\s*已禁用$/, (_, name) => `Problem ${name} disabled`],
  [/^Problem\s*(.+)\s*已启用$/, (_, name) => `Problem ${name} enabled`],
  [/^最多\s*(\d+)\s*个文件$/, (_, n) => `Up to ${n} files`],
  [/^最大\s*(.+)$/, (_, value) => `Max ${value}`],
  [/^剩余\s*(\d+)天(\d+)小时$/, (_, d, h) => `${d}d ${h}h left`],
  [/^剩余\s*(\d+)小时$/, (_, h) => `${h}h left`],
  [/^剩余\s*(\d+)分钟$/, (_, m) => `${m}m left`],
  [/^(.+)\s*人\/班$/, (_, count) => `${count} students/class`],
  [/^(\d+(?:\.\d+)?)分$/, (_, s) => `${s} pts`],
  [/^(\d+)人$/, (_, c) => `${c} people`],
  [/^学生(\d+)$/, (_, id) => `Student ${id}`],
  [/^题目 (\d+)$/, (_, id) => `Problem ${id}`],
  [/^生成于 (.+)$/, (_, at) => `Generated at ${at}`],
  [/^参赛人数：(.+)$/, (_, c) => `Participants: ${c}`],
  [/^最多(\d+)个字符（(.+)）$/, (_, n, cur) => `Max ${n} characters (${cur})`],
  [/^班级容量不能超过班级最大容量\((\d+)\)$/, (_, n) => `Class capacity cannot exceed max capacity (${n})`],
  [/^共(\d+)题$/, (_, n) => `${n} problems`],
  [/^创建于\s*(.+)$/, (_, value) => `Created At ${value}`],
  [/^Create于\s*(.+)$/, (_, value) => `Created At ${value}`],
  [/^加入截止\s*(.+)$/, (_, value) => `Join Deadline ${value === '未限制' ? 'No Limit' : value}`],
  [/^Class口令[：:]\s*(.+)$/, (_, value) => `Class Invitation Code: ${value}`],
  [/^Class邀请码[：:]\s*(.+)$/, (_, value) => `Class Invitation Code: ${value}`],
  [/^班级口令[：:]\s*(.+)$/, (_, value) => `Class Invitation Code: ${value}`],
  [/^班级邀请码[：:]\s*(.+)$/, (_, value) => `Class Invitation Code: ${value}`],
  [/^班级口令(?![：:])\s*(.+)$/, (_, value) => `Class Invitation Code ${value}`],
  [/^班级邀请码(?![：:])\s*(.+)$/, (_, value) => `Class Invitation Code ${value}`],
  [/^邀请码\s*(.+)$/, (_, value) => `Class Invitation Code ${value}`],
  [/^口令\s*(.+)$/, (_, value) => `Class Invitation Code ${value}`],
  [/^容量\s*(.+)$/, (_, value) => `Capacity ${value}`],
  [/^结束时间\s*不能早于开始时间$/, () => 'End Time cannot be earlier than Start Time'],
  [/^End Time\s*不能早于开始时间$/, () => 'End Time cannot be earlier than Start Time'],
  [/^开始时间\s*[:：]?\s*(.+)$/, (_, value) => `Start Time ${value}`],
  [/^结束时间\s*[:：]?\s*(.+)$/, (_, value) => `End Time ${value}`],
  [/^确定要立即结束任务[“"「]?(.*?)[”"」]?吗？结束后学生将无法继续提交。$/, (_, name) => `End task "${name}" now? Students will no longer be able to submit.`],
  [/^确定要立即结束Task[“"「]?(.*?)[”"」]?吗？结束后Student将无法继续Submit。$/, (_, name) => `End task "${name}" now? Students will no longer be able to submit.`],
  [/^当前结束时间\s*[:：]\s*(.+)$/, (_, value) => `Current End Time: ${value}`],
  [/^延长后结束时间\s*[:：]\s*(.+)$/, (_, value) => `New End Time: ${value}`],
  [/^延长(\d+)\s*小时$/, (_, n) => `Extend by ${n} h`],
  [/^延长(\d+)\s*天$/, (_, n) => `Extend by ${n} d`],
  [/^难度\s*[:：]\s*(.+)$/, (_, value) => `Difficulty: ${value}`],
  [/^状态\s*[:：]\s*(.+)$/, (_, value) => `Status: ${applyTokenRules(value)}`],
  [/^状态\s*[:：]?$/, () => 'Status'],
  [/^(已选题目|Selected Problems)\s*(\d+)\s*个$/, (_, __, count) => `Selected Problems ${count}`],
  [/^(\d+)\s*个$/, (_, count) => `${count} items`],
  [/^类型\s*(.+)$/, (_, t) => `Type ${applyTokenRules(t)}`],
  [/^(.*)(提交率|Submit率)$/, (_, prefix) => `${prefix ? `${applyTokenRules(prefix)} ` : ''}Submission Rate`],
  [/^(.*)(题目数|Problem数)$/, (_, prefix) => `${prefix ? `${applyTokenRules(prefix)} ` : ''}Problem Count`],
  [/^操作成功$/, () => 'Operation succeeded'],
  [/^教师ID\s*(.+)$/, (_, id) => `Teacher ID ${id}`],
  [/^教师\s*(.+)$/, (_, name) => `Teacher ${name}`],
  [/^Teacher\s*(.+)$/, (_, name) => `Teacher ${name}`],
  [/^教师提醒\s*(\d+)\s*次$/, (_, count) => `Teacher reminded ${count} times`],
  [/^确定要退出任务[「""]?(.*?)[」""]?吗？退出后将清空已提交内容。$/, (_, name) => `Leave task "${name}"? All submitted content will be cleared.`],
  [/^(\d+)\s*题$/, (_, n) => `${n} Problems`],
  [/^允许格式:\s*(.+)$/, (_, ext) => `Allowed formats: ${ext}`],
  [/^需提交\s*(\d+)\s*个文件$/, (_, n) => `Submit ${n} files`],
  [/^(\d+)\s*个文件规则$/, (_, n) => `${n} file rule${Number(n) === 1 ? '' : 's'}`],
  [/^文件\s*(\d+)$/, (_, n) => `File ${n}`],
  [/^格式:\s*(.+)$/, (_, ext) => `Format: ${ext}`],
  [/^大小\s*≤\s*(.+)$/, (_, size) => `Size ≤ ${size}`],
  [/^(.+)（重新选择）$/, (_, name) => `${name} (Reselect)`],
  [/^已提交:\s*(.+)$/, (_, info) => `Submitted: ${info}`],
  [/^(.+)\s*等(\d+)个文件$/, (_, name, n) => `${name} and ${n} files`],
  [/^题目\s*"(.+)"\s*已成功提交$/, (_, name) => `Problem "${name}" submitted successfully`],
  [/^已加载模板["“]?(.*?)["”]?的提交文件要求$/, (_, name) => `Loaded submission file requirements from template "${name}"`],
  [/^确定删除模板["“]?(.*?)["”]?？删除后不可恢复。$/, (_, name) => `Delete template "${name}"? This action cannot be undone.`],
  [/^人数:\s*(\d+)$/, (_, n) => `Students: ${n}`],
  [/^教师:\s*(.+)$/, (_, name) => `Teacher: ${name}`]
]

const REVERSE_REGEX_RULES = [
  [/^Start Time\s*[:：]?\s*(.+)$/i, (_, value) => `开始时间 ${value}`],
  [/^End Time\s*[:：]?\s*(.+)$/i, (_, value) => `结束时间 ${value}`],
  [/^Created At\s*(.+)$/i, (_, value) => `创建于 ${value}`],
  [/^Join Deadline\s*No Limit$/i, () => '加入截止 未限制'],
  [/^Join Deadline\s*(.+)$/i, (_, value) => `加入截止 ${value}`],
  [/^Class Invitation Code:\s*(.+)$/i, (_, value) => `班级邀请码：${value}`],
  [/^Class Invitation Code\s+(.+)$/i, (_, value) => `班级邀请码 ${value}`],
  [/^Class Code:\s*(.+)$/i, (_, value) => `班级邀请码：${value}`],
  [/^Class Code\s+(.+)$/i, (_, value) => `班级邀请码 ${value}`],
  [/^Invitation Code:\s*(.+)$/i, (_, value) => `班级邀请码：${value}`],
  [/^Invitation Code\s+(.+)$/i, (_, value) => `班级邀请码 ${value}`],
  [/^Code\s*(.+)$/i, (_, value) => `班级邀请码 ${value}`],
  [/^Capacity\s*(.+)$/i, (_, value) => `容量 ${value}`],
  [/^End Time cannot be earlier than Start Time$/i, () => '结束时间不能早于开始时间'],
  [/^Delete task "(.*)"\?$/i, (_, name) => `确认删除任务「${name}」吗？`],
  [/^Delete class "(.*)"\?$/i, (_, name) => `确定要删除班级「${name}」吗？`],
  [/^Delete class "(.*)"\? This action cannot be undone\.$/i, (_, name) => `确定要删除班级“${name}”吗？删除后将无法恢复。`],
  [/^Class disabled$/i, () => '班级已禁用'],
  [/^Class enabled$/i, () => '班级已启用'],
  [/^Class\s+(.+)\s+disabled$/i, (_, name) => `班级 ${name} 已禁用`],
  [/^Class\s+(.+)\s+enabled$/i, (_, name) => `班级 ${name} 已启用`],
  [/^Up to\s+(\d+)\s+files$/i, (_, n) => `最多 ${n} 个文件`],
  [/^Max\s+(.+)$/i, (_, value) => `最大 ${value}`],
  [/^End task "(.*)" now\? Students will no longer be able to submit\.$/i, (_, name) => `确定要立即结束任务"${name}"吗？结束后学生将无法继续提交。`],
  [/^Current End Time:\s*(.+)$/i, (_, value) => `当前结束时间：${value}`],
  [/^New End Time:\s*(.+)$/i, (_, value) => `延长后结束时间：${value}`],
  [/^Extend by (\d+)\s*h$/i, (_, n) => `延长${n}小时`],
  [/^Extend by (\d+)\s*d$/i, (_, n) => `延长${n}天`],
  [/^Difficulty\s*:\s*(.+)$/i, (_, value) => `难度：${value}`],
  [/^status\s*:\s*(.+)$/i, (_, value) => `状态：${value}`],
  [/^status$/i, () => '状态'],
  [/^Selected Problems\s*(\d+)$/i, (_, count) => `已选题目 ${count} 个`],
  [/^(\d+)\s*items$/i, (_, count) => `${count} 个`],
  [/^(\d+)\s*Problems$/i, (_, n) => `${n} 题`],
  [/^Allowed formats:\s*(.+)$/i, (_, ext) => `允许格式: ${ext}`],
  [/^Submit\s*(\d+)\s*files$/i, (_, n) => `需提交 ${n} 个文件`],
  [/^File\s*(\d+)$/i, (_, n) => `文件 ${n}`],
  [/^Format:\s*(.+)$/i, (_, ext) => `格式: ${ext}`],
  [/^Size\s*≤\s*(.+)$/i, (_, size) => `大小 ≤ ${size}`],
  [/^(.+)\s*\(Reselect\)$/i, (_, name) => `${name}（重新选择）`],
  [/^Submitted:\s*(.+)$/i, (_, info) => `已提交: ${info}`],
  [/^(.+)\s*and\s*(\d+)\s*files$/i, (_, name, n) => `${name} 等${n}个文件`],
  [/^Problem\s*"(.+)"\s*submitted successfully$/i, (_, name) => `题目 "${name}" 已成功提交`],
  [/^Students:\s*(\d+)$/i, (_, n) => `人数: ${n}`],
  [/^Teacher:\s*(.+)$/i, (_, name) => `教师: ${name}`]
]

const TOKEN_ENTRIES = Object.entries(TOKEN_TEXT_MAP).sort((a, b) => b[0].length - a[0].length)
const EXACT_TEXT_MAP_EN_TO_ZH = Object.fromEntries(
  Object.entries(EXACT_TEXT_MAP).map(([zh, en]) => [en, zh])
)
const listeners = new Set()

const normalizeLocale = (locale) => {
  if (typeof locale !== 'string') return LOCALE_ZH
  return locale.toLowerCase().startsWith('en') ? LOCALE_EN : LOCALE_ZH
}

const detectInitialLocale = () => {
  const stored = localStorage.getItem(LOCALE_STORAGE_KEY)
  if (stored) return normalizeLocale(stored)
  const browserLocale = typeof navigator !== 'undefined' ? navigator.language : LOCALE_ZH
  return normalizeLocale(browserLocale)
}

let currentLocale = detectInitialLocale()

const hasHan = (text) => /[\u4e00-\u9fff]/.test(text)

const preserveEdgeWhitespace = (source, translated) => {
  const leading = source.match(/^\s*/)?.[0] || ''
  const trailing = source.match(/\s*$/)?.[0] || ''
  return `${leading}${translated}${trailing}`
}

const applyRegexRules = (text) => {
  for (const [pattern, replacer] of REGEX_RULES) {
    if (pattern.test(text)) {
      return text.replace(pattern, replacer)
    }
  }
  return null
}

const applyReverseRegexRules = (text) => {
  for (const [pattern, replacer] of REVERSE_REGEX_RULES) {
    if (pattern.test(text)) {
      return text.replace(pattern, replacer)
    }
  }
  return null
}

const applyTokenRules = (text) => {
  let output = text
  for (const [zh, en] of TOKEN_ENTRIES) {
    output = output.split(zh).join(en)
  }
  return output
    .replace(/\bWe Chat\b/g, 'WeChat')
    .replace(/\bGit Hub\b/g, 'GitHub')
    .replace(/\bGit Code\b/g, 'GitCode')
    .replace(/\s{2,}/g, ' ')
    .trim()
}

export const getLocale = () => currentLocale

export const setLocale = (locale) => {
  const next = normalizeLocale(locale)
  if (next === currentLocale) return
  currentLocale = next
  localStorage.setItem(LOCALE_STORAGE_KEY, next)
  listeners.forEach((listener) => {
    try {
      listener(next)
    } catch (error) {
      // Keep locale switching resilient; translation listeners are optional.
      console.error('Locale listener error:', error)
    }
  })
}

export const toggleLocale = () => {
  setLocale(currentLocale === LOCALE_ZH ? LOCALE_EN : LOCALE_ZH)
}

export const onLocaleChange = (listener) => {
  if (typeof listener !== 'function') return () => {}
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export const translateText = (text, locale = currentLocale) => {
  if (typeof text !== 'string' || !text) return text
  const normalized = normalizeLocale(locale)

  if (normalized !== LOCALE_EN) {
    const trimmed = text.trim()
    if (!trimmed || hasHan(trimmed)) return text

    const reverseRegexMatched = applyReverseRegexRules(trimmed)
    if (reverseRegexMatched) return preserveEdgeWhitespace(text, reverseRegexMatched)

    const reverseExact = EXACT_TEXT_MAP_EN_TO_ZH[trimmed]
    if (reverseExact) return preserveEdgeWhitespace(text, reverseExact)

    return text
  }

  const trimmed = text.trim()
  if (!trimmed || !hasHan(trimmed)) return text

  const exact = EXACT_TEXT_MAP[trimmed]
  if (exact) return preserveEdgeWhitespace(text, exact)

  const regexMatched = applyRegexRules(trimmed)
  if (regexMatched) return preserveEdgeWhitespace(text, regexMatched)

  const tokenTranslated = applyTokenRules(trimmed)
  if (tokenTranslated !== trimmed) {
    return preserveEdgeWhitespace(text, tokenTranslated)
  }

  return text
}

export const installI18n = (app) => {
  app.config.globalProperties.$t = (text) => translateText(text, getLocale())
  app.config.globalProperties.$locale = () => getLocale()
  app.config.globalProperties.$setLocale = (locale) => setLocale(locale)
  app.config.globalProperties.$toggleLocale = () => toggleLocale()
}
